import React, { useCallback, useState, useEffect } from "react";
import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";
import ButtonBase from "@material-ui/core/ButtonBase";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Paper from "@material-ui/core/Paper";
import useMedia from "use-media";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import abdominal from "../../img/abdominal.jpg";
import aerobic from "../../img/aerobic.jpg";
import arm from "../../img/arm.jpg";
import back from "../../img/back.jpg";
import butt from "../../img/butt.jpg";
import chest from "../../img/chest.jpg";
import legs from "../../img/legs.jpg";
import shoulder from "../../img/shoulder.jpg";
import original from "../../img/original.jpg";

import {
  fetchAsyncGetFavoriteMenu,
  fetchAsyncGetMenu,
  selectMenuCategory,
  selectSelectedMenuCategory,
} from "../home/homeSlice";
import { SELECT_MENU_CATEGORY } from "../../types/types";
import { selectLoginUser } from "../auth/authSlice";

const categoryPanel = [
  {
    title: "胸",
    titleSub: " -Chest",
    part: "1",
    part_name: "胸",
    url: chest,
    width: "40%",
  },
  {
    title: "脚",
    titleSub: " -Legs",
    part: "5",
    part_name: "脚",
    url: legs,
    width: "40%",
  },
  {
    title: "背中",
    titleSub: " -Back",
    part: "4",
    part_name: "背",
    url: back,
    width: "40%",
  },
  {
    title: "肩",
    titleSub: " -Shoulder",
    part: "6",
    part_name: "肩",
    url: shoulder,
    width: "10%",
  },
  {
    title: "腕",
    titleSub: " -Arm",
    part: "3",
    part_name: "腕",
    url: arm,
    width: "40%",
  },
  {
    title: "腹",
    titleSub: " -Abdominal",
    part: "2",
    part_name: "腹",
    url: abdominal,
    width: "40%",
  },
  {
    title: "尻",
    titleSub: " -Butt",
    part: "7",
    part_name: "尻",
    url: butt,
    width: "40%",
  },
  {
    title: "有酸素",
    titleSub: " -Aerobic",
    part: "8",
    part_name: "有",
    url: aerobic,
    width: "40%",
  },
];

const myMenu = {
  title: "My menu",
  titleSub: "",
  part: "0",
  part_name: "オリジナルメニュー",
  url: original,
  width: "40%",
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexWrap: "wrap",
      minWidth: 300,
      width: "100%",
      marginTop: theme.spacing(11),
      marginBottom: theme.spacing(7),
    },
    image: {
      position: "relative",
      height: 200,
      marginBottom: 1,
      boxShadow: "0 0.3rem 1em rgba(255,255,255,0.4)",
      [theme.breakpoints.down("xs")]: {
        width: "50% !important", // Overrides inline-style
        height: 100,
      },
      "&:hover, &$focusVisible": {
        zIndex: 1,
        "& $imageBackdrop": {
          opacity: 0.15,
        },
        "& $imageMarked": {
          opacity: 0,
        },
        "& $imageButton": {
          border: "4px solid currentColor",
        },
      },
    },
    imageMyMenu: {
      position: "relative",
      height: 200,
      boxShadow: "0 0.3rem 1em rgba(255,255,255,0.4)",
      [theme.breakpoints.down("xs")]: {
        width: "100% !important", // Overrides inline-style
        height: 100,
      },
      "&:hover, &$focusVisible": {
        zIndex: 1,
        "& $imageBackdrop": {
          opacity: 0.15,
        },
        "& $imageMarked": {
          opacity: 0,
        },
        "& $imageTitle": {
          border: "4px solid currentColor",
        },
      },
    },
    focusVisible: {},
    imageButton: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.palette.common.white,
    },
    imageSrc: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundSize: "cover",
      backgroundPosition: "center 45%",
    },
    imageBackdrop: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundColor: theme.palette.common.black,
      opacity: 0.4,
      transition: theme.transitions.create("opacity"),
    },
    imageTitle: {
      position: "relative",
      padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${
        theme.spacing(1) + 6
      }px`,
    },
    imageMarked: {
      height: 3,
      width: 18,
      backgroundColor: theme.palette.common.white,
      position: "absolute",
      bottom: -2,
      left: "calc(50% - 9px)",
      transition: theme.transitions.create("opacity"),
    },
    paper: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      position: "fixed",
      width: "100%",
      margin: 0,
      boxSizing: "border-box",
      zIndex: 2,
      backgroundColor: "#f1f9ff",
      maxWidth: "66.667%",
      padding: theme.spacing(2),
      height: 68,
    },
    paperRes: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      position: "fixed",
      justifyContent: "space-between",
      width: "100%",
      margin: 0,
      boxSizing: "border-box",
      zIndex: 2,
      backgroundColor: "#f1f9ff",
      padding: theme.spacing(2),
      height: 68,
    },
    gridContainer: {
      zIndex: 3,
      height: "100vh",
    },
    titleFont: {
      fontWeight: "bold",
      fontSize: 20,
    },
    circulContainer: {
      position: "absolute",
      transform: "translate(-50%, -50%)",
      top: "50%",
      left: "50%",
      zIndex: 3,
    },
  })
);

const MenuCategory: React.FC = () => {
  const classes = useStyles();
  const isWide = useMedia({ minWidth: "600px" });
  const history = useHistory();
  const dispatch = useDispatch();
  const loginUser = useSelector(selectLoginUser);
  const [isLoading, setIsLoading] = useState(false);

  const backPage = useCallback(() => {
    history.push("/home/record/board");
  }, [history]);

  const handleSelectCategory = useCallback(
    async (category: SELECT_MENU_CATEGORY) => {
      await setIsLoading(true);
      await dispatch(fetchAsyncGetMenu(category.part));
      await dispatch(fetchAsyncGetFavoriteMenu());
      await dispatch(selectMenuCategory(category));
      await history.push("/home/menu/list");
      await setIsLoading(false);
    },
    [dispatch]
  );

  const renderPanel = () => {
    return categoryPanel.map((category) => (
      <ButtonBase
        focusRipple
        key={category.title}
        className={classes.image}
        focusVisibleClassName={classes.focusVisible}
        style={{
          width: category.width,
        }}
        onClick={() => handleSelectCategory(category)}
      >
        <span
          className={classes.imageSrc}
          style={{
            backgroundImage: `url(${category.url})`,
          }}
        />
        <span className={classes.imageBackdrop} />
        <span className={classes.imageButton}>
          <Typography
            component="span"
            variant="subtitle1"
            color="inherit"
            className={classes.imageTitle}
          >
            <span className={classes.titleFont}>{category.title}</span>
            {category.titleSub}
            <span className={classes.imageMarked} />
          </Typography>
        </span>
      </ButtonBase>
    ));
  };

  useEffect(() => {
    loginUser.id === 0 && history.push("/home");
  }, [history]);

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        className={classes.gridContainer}
        component={Paper}
        elevation={6}
        square
      >
        {isLoading && (
          <div className={classes.circulContainer}>
            <CircularProgress />
          </div>
        )}
        <div className={isWide ? classes.paper : classes.paperRes}>
          <div>
            <ArrowBackIcon onClick={backPage} />
          </div>
        </div>
        <div className={classes.root}>
          {renderPanel()}
          <ButtonBase
            focusRipple
            key={myMenu.title}
            className={classes.imageMyMenu}
            focusVisibleClassName={classes.focusVisible}
            style={{
              width: myMenu.width,
            }}
            onClick={() => handleSelectCategory(myMenu)}
          >
            <span
              className={classes.imageSrc}
              style={{
                backgroundImage: `url(${myMenu.url})`,
              }}
            />
            <span className={classes.imageBackdrop} />
            <span className={classes.imageButton}>
              <Typography
                component="span"
                variant="subtitle1"
                color="inherit"
                className={classes.imageTitle}
              >
                <span className={classes.titleFont}>{myMenu.title}</span>

                <span className={classes.imageMarked} />
              </Typography>
            </span>
          </ButtonBase>
        </div>
      </Grid>
    </Grid>
  );
};

export default MenuCategory;
